module.exports = __webpack_public_path__ + "static/profile-pic.cb7b6d4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/profile-pic.jpg
// module id = 312
// module chunks = 35783957827783 107818501498521